import { render, staticRenderFns } from "./TransactionListComponent.vue?vue&type=template&id=2d2f46fc&"
import script from "./TransactionListComponent.vue?vue&type=script&lang=js&"
export * from "./TransactionListComponent.vue?vue&type=script&lang=js&"
import style0 from "./TransactionListComponent.vue?vue&type=style&index=0&id=2d2f46fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports